import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import { SearchIcon } from "@/components/icons";
import { Input } from "@/components/ui/text-field";
import { enterUgcArticle, looksLikeUgcArticle, resolveUgcCode, ugcResolveKey } from "@/lib/ugc-search";
import { cn } from "@/lib/utils";

// Storefront search. Submitting routes to the catalog with `?search=`, which
// the catalog page reads to drive the gateway query. Stays in sync with the
// URL so the field reflects the active search when you land on /?search=…
//
// Цифровой UGC-артикул (8 цифр, ТЗ 31.10.2026): сначала резолв по реестру.
// Активный - сразу карточка товара; нет такого или отключён - выдача каталога
// с сообщением (ответ резолва кладётся в кэш, каталог второй раз не спрашивает).
export function SearchBar(t0) {
  const $ = _c(29);
  const {
    className,
    onSubmitted,
    onDark: t1
  } = t0;
  const onDark = t1 === undefined ? false : t1;
  const {
    t
  } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const queryClient = useQueryClient();
  let t2;
  if ($[0] !== params) {
    t2 = params.get("search") ?? "";
    $[0] = params;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [value, setValue] = useState(t2);
  const [resolving, setResolving] = useState(false);
  let t3;
  let t4;
  if ($[2] !== params) {
    t3 = () => {
      setValue(params.get("search") ?? "");
    };
    t4 = [params];
    $[2] = params;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== navigate || $[6] !== onSubmitted || $[7] !== queryClient || $[8] !== resolving || $[9] !== value) {
    t5 = async e => {
      e.preventDefault();
      const q = value.trim();
      if (q && looksLikeUgcArticle(q)) {
        if (resolving) {
          return;
        }
        setResolving(true);
        const result = await resolveUgcCode(q);
        setResolving(false);
        if (result?.found) {
          enterUgcArticle(result, navigate);
          onSubmitted?.();
          return;
        }
        if (result) {
          queryClient.setQueryData(ugcResolveKey(q), result);
        }
      }
      navigate(q ? `/catalog?search=${encodeURIComponent(q)}` : "/catalog");
      onSubmitted?.();
    };
    $[5] = navigate;
    $[6] = onSubmitted;
    $[7] = queryClient;
    $[8] = resolving;
    $[9] = value;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = resolving || undefined;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_0 => setValue(e_0.target.value);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("header.searchPlaceholder");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t("header.search");
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SearchIcon size={16} />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = onDark && "border-transparent";
  let t12;
  if ($[17] !== t11) {
    t12 = cn(t11);
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t8 || $[21] !== t9 || $[22] !== value) {
    t13 = <Input variant="search" type="search" value={value} onChange={t7} placeholder={t8} aria-label={t9} start={t10} fieldClassName={t12} />;
    $[19] = t12;
    $[20] = t8;
    $[21] = t9;
    $[22] = value;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== className || $[25] !== t13 || $[26] !== t5 || $[27] !== t6) {
    t14 = <form role="search" onSubmit={t5} aria-busy={t6} className={className}>{t13}</form>;
    $[24] = className;
    $[25] = t13;
    $[26] = t5;
    $[27] = t6;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}